import React, { useState } from 'react';
import TextField from 'ui/elements/form/TextField';
import Button from 'ui/elements/buttons/Button';
import useLazyResource from 'util/resource/useLazyResource';
import styled from '@emotion/styled';
import { contentSpacing, halfSpacing } from 'ui/theme/themeConstants';

interface Props {
  onSubmit: (text: string) => Promise<void>;
  placeholder?: string;
}

const FormContainer = styled.div`
  display: flex;
  gap: ${halfSpacing};
  min-width: 100%;
  align-items: center;
  margin-top: ${contentSpacing};
  margin-bottom: ${contentSpacing};
`;

export default function CommentForm({ onSubmit, placeholder = 'Add a comment...' }: Props) {
  const [text, setText] = useState('');

  const [submitComment, isSubmitting] = useLazyResource((commentText: string) => onSubmit(commentText), {
    onSuccess: () => {
      setText('');
    },
  });

  return (
    <FormContainer>
      <TextField
        value={text}
        onChange={e => setText(e.target.value)}
        placeholder={placeholder}
        multiline
        minRows={1}
        maxRows={6}
        fullWidth
      />
      <Button
        onClick={() => submitComment(text)}
        kind="primary"
        size="small"
        isLoading={isSubmitting}
        disabled={text.trim().length === 0 || isSubmitting}
        style={{ height: 44 }}
      >
        Send
      </Button>
    </FormContainer>
  );
}
